import Reflux from 'reflux';
import storeUtils from '../../utils/store';

window.STORES = window.STORES || {};

export default class TranslationStore extends Reflux.Store {
  static id = 'translations';

  constructor () {
    super();
    window.STORES.translations = this;
    this.state = storeUtils.get('translations');
  }

  get (module, textUnit, variables) {
    const hasTranslation = () =>
      this.state[module] &&
      (typeof this.state[module][textUnit] === 'string' ||
        typeof this.state[module][textUnit] === 'object');

    // make sure two arguments are supplied
    if (!textUnit) {
      return {
        status: -1,
        text: 'No module defined for TU: ' + module
      };
    }

    if (hasTranslation()) {
      var tu = this.state[module][textUnit];

      if (variables) {
        for (var variable in variables) {
          tu = tu.replace(variable, variables[variable]);
        }
      }

      return {
        status: 0,
        text: tu
      };
    }
    else {
      return {
        status: -2,
        text: 'No TU found for: ' + textUnit
      };
    }
  }
}



// WEBPACK FOOTER //
// ./frontend/react/stores/translations/index.js